import { useState, useEffect } from 'react';
import { useObservacoesProfessorPage } from './useObservacoesProfessorPage';
import { ObservacoesProfessorDesktop } from './ObservacoesProfessorDesktop';
import { ObservacoesMobileView } from './ObservacoesMobileView';

function useIsMobile(bp = 768) {
  const [m, setM] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < bp : false,
  );
  useEffect(() => {
    const fn = () => setM(window.innerWidth < bp);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, [bp]);
  return m;
}

export function ObservacoesPage() {
  const isMobile = useIsMobile();
  const ctx = useObservacoesProfessorPage();

  if (!isMobile) {
    return (
      <div
        className="obs-desk-host"
        style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
      >
        <ObservacoesProfessorDesktop ctx={ctx} />
      </div>
    );
  }

  return <ObservacoesMobileView ctx={ctx} />;
}
